import React from 'react';
import { Form } from 'react-bootstrap';
import Select from 'react-select';

function MultiSelect({
  id,
  name,
  options,
  isClearable,
  value,
  placeholder,
  handleChange,
  label,
  classLabel,
  required
}) {
  return (
    <Form.Group className='mb-2'>
      {label && <Form.Label htmlFor={id} className={classLabel}>{label}</Form.Label>}
      {required && <span className='text-danger'>*</span>}
      <Select
        id={id}
        name={name}
        isClearable={isClearable}
        placeholder={placeholder}
        options={options}
        onChange={handleChange}
        value={value}
        isMulti
        className='basic-multi-select'
        classNamePrefix='select'
      />
    </Form.Group>
  );
}

export default MultiSelect;
